import { Component, EventEmitter, Input, Output } from '@angular/core';
import { User } from '@account-users/user/models/User';
import { UserRolesAndPermissionsService } from '@account-users/user/services/user-roles-and-permissions.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-user-mfa',
  templateUrl: './user-mfa.component.html',
  styleUrls: ['./user-mfa.component.scss'],
})
export class UserMfaComponent {
  @Input() user: User;
  @Input() google: boolean;
  @Input() mobile: boolean;
  @Output() removeMfaVerify = new EventEmitter();

  public hasOnlyTrialDispenserRole$: Observable<boolean>;

  constructor(
    private readonly userRolesService: UserRolesAndPermissionsService,
  ) {
    this.hasOnlyTrialDispenserRole$ = this.userRolesService.hasOnlyTrialDispenserRole$;
  }
}
